// extracted by mini-css-extract-plugin
module.exports = {"messages":"Messages_messages__1T36Z","empty":"Messages_empty__BaLOo"};